module.exports = __webpack_public_path__ + "static/media/education-image.a24786c4.jpg";